import { IMG } from '../../const';

import './loader.scss';

const Loader = () => (
  <div className="report-page__loader animated">
    <picture>
      <source
        media="(max-width: 900px)"
        srcSet={`${IMG.QUICK_QUOTE}/page-skeleton-mob.svg`}
        type="image/svg+xml"
      />

      <source
        media="(min-width: 901px)"
        srcSet={`${IMG.QUICK_QUOTE}/page-skeleton.svg`}
        type="image/svg+xml"
      />

      <img
        src={`${IMG.QUICK_QUOTE}/page-skeleton.svg`}
        alt="Loader"
        width="976"
        height="896"
      />
    </picture>
  </div>
);

export default Loader;
